import { render, staticRenderFns } from "./lista-solicitacoes-db.vue?vue&type=template&id=cf320fc2"
import script from "./lista-solicitacoes-db.vue?vue&type=script&lang=js"
export * from "./lista-solicitacoes-db.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports